<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="isIcon"
        style="min-width: 30px"
        color="secondary"
        class="px-2 py-5 mr-1"
        :class="newClass"
        depressed
        text
        v-bind="{ ...attrs, ...$attrs }"
        v-on="{ ...on, ...$listeners }"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-btn
        v-else
        small
        class="btn-small rounded-lg mr-1"
        :class="newClass"
        color="primary"
        outlined
        v-bind="{ ...attrs, ...$attrs }"
        v-on="{ ...on, ...$listeners }"
      >
        <v-icon class="mr-2" small>mdi-refresh</v-icon>
        <span>Refresh</span>
      </v-btn>
    </template>
    <span class="text-capitalize">refresh list</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    isIcon: {
      type: Boolean,
      default: true,
    },
    newClass: {
      type: String,
    },
  },
};
</script>
<style scoped>
.btn-small {
  /* min-width: 34px !important;
  width: 34px !important; */
  height: 34px !important;
}
</style>
